import { widgetState } from '../../store/customizations/index'

export const tilesTemplate = () => {
  return `
    <label style="margin-bottom: 0" class="yotpo-radio-label">
        <input class="yotpo-radio-label-input yotpo-selling-plan-radio-label {{checkedClassFn}}"
               data-selling-plan-name="{{inputAttributes.data}}"
               type="radio"
               name="{{inputAttributes.name}}"
               value="{{value}}" {{{checkedFn}}}>
        <span style="cursor: pointer" class="yotpo-radio-label-text">{{text}}</span>
    </label>
    <style>
        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label .yotpo-radio-label-text {
          font-size: ${widgetState.customizations.styles.fontSize.sellingPlans.name};
          font-family: ${widgetState.customizations.styles.fontFamily.name};
          font-style: normal;
          font-weight: ${widgetState.customizations.styles.fontFamily.weight || 500};
          color: ${widgetState.customizations.styles.colors.text.primary};
          display: table-cell;
          vertical-align: middle;
          text-align: center;
        }
        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input {
          appearance: none;
          -webkit-appearance: none;
          border: none;
          background: none;
          display: none;
        }
    </style>`
}
